import { useState } from 'react';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';
import { getProductsBySku } from 'services/api/products';
import { getProductDetails } from 'services/gifts';

const Camera = ({ setShowModal, setProducts }) => {
  const [, setShowData] = useState('no se detecta camara');

  const onUpdate = async (_, result) => {
    if (result) {
      const variant = await getProductsBySku({
        sku: result.text,
      });
      const productId = variant?.length ? variant[0].id : 0;
      const product = +productId ? [await getProductDetails(productId)] : [];
      setProducts(product);
      setShowData(result.text);
      setShowModal(true);
    }
  };

  return (
    <div>
      <BarcodeScannerComponent width="100%" height="auto" onUpdate={onUpdate} />
    </div>
  );
};

export default Camera;
